import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { finalBadges } from '../data/copy';
export function FinalCtaSection() {
  return <section className="w-full bg-ivory py-14 sm:py-16" aria-labelledby="final-cta-heading" data-id="element-63" data-mp="3lw9eanbv0hzt">
      <div className="mx-auto max-w-4xl px-6" data-id="element-64" data-mp="3qrou3ktfgnyv">
        <div className="rounded-4xl bg-sage-deep px-7 py-12 text-center shadow-lift sm:px-12" data-id="element-65" data-mp="3vrkw5eike5bs">
          <p className="eyebrow text-gold-soft" data-id="element-66" data-mp="2y5x04uq0tp0s">Your next class</p>
          <h2 id="final-cta-heading" className="mx-auto mt-5 max-w-xl font-display text-[2rem] leading-[1.12] text-ivory sm:text-4xl" data-id="element-67" data-mp="333yljmax60ff">
            Your next class doesn’t have to start with a blank page.
          </h2>
          <p className="mx-auto mt-4 max-w-lg font-display text-xl leading-snug text-gold-soft" data-id="element-68" data-mp="3cu9vpql755ur">
            It can start with Yoga Teaching Vault™.
          </p>

          <CtaButton size="large" className="mt-9" data-id="element-69" data-mp="2fcjn44m9k39g">
            Get the complete Vault — $27
          </CtaButton>

          <ul className="mt-7 flex flex-wrap items-center justify-center gap-x-5 gap-y-2" data-id="element-70" data-mp="2dbqm552wp3v8">
            {finalBadges.map(badge => <li key={badge} className="flex items-center gap-1.5 font-sans text-[11px] text-ivory/70" data-id="element-71" data-mp="28cdrhy5smsi3">
                <CheckIcon className="h-3.5 w-3.5 text-gold" strokeWidth={2.4} aria-hidden="true" data-id="element-72" data-mp="23lf4ygu7oy6e" />
                {badge}
              </li>)}
          </ul>
        </div>

        <p className="mx-auto mt-10 max-w-xl text-center font-display text-xl leading-snug text-ink" data-id="element-73" data-mp="1ulio31e2d3lw">
          Your energy belongs in the room with your students — not on another
          Sunday night staring at a blank class plan.
        </p>
      </div>
    </section>;
}